export default function FormatData(data: string): Uint8Array {
  var byteCharacters = atob(data)
  var byteNumbers = new Array(byteCharacters.length)

  for (var k = 0; k < byteCharacters.length; k++) {
    byteNumbers[k] = byteCharacters.charCodeAt(k)
  }

  var byteArray = new Uint8Array(byteNumbers)
  return byteArray
}